var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 44,
    viewBox: "0 0 149 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.882812,
    y: 0.5,
    width: 147.5,
    height: 43,
    rx: 4.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.882812,
    y: 0.5,
    width: 147.5,
    height: 43,
    rx: 4.5,
    stroke: "#A6A6A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.3327 23.9264C72.7455 23.9264 70.6368 25.8943 70.6368 28.6047C70.6368 31.2986 72.7455 33.283 75.3327 33.283C77.921 33.283 80.0297 31.2986 80.0297 28.6047C80.0286 25.8943 77.9199 23.9264 75.3327 23.9264ZM75.3327 31.4416C73.9148 31.4416 72.6927 30.2723 72.6927 28.6058C72.6927 26.9217 73.9159 25.77 75.3327 25.77C76.7506 25.77 77.9727 26.9217 77.9727 28.6058C77.9727 30.2712 76.7506 31.4416 75.3327 31.4416ZM65.0873 23.9264C62.5001 23.9264 60.3914 25.8943 60.3914 28.6047C60.3914 31.2986 62.5001 33.283 65.0873 33.283C67.6756 33.283 69.7843 31.2986 69.7843 28.6047C69.7843 25.8943 67.6756 23.9264 65.0873 23.9264ZM65.0873 31.4416C63.6694 31.4416 62.4473 30.2723 62.4473 28.6058C62.4473 26.9217 63.6705 25.77 65.0873 25.77C66.5052 25.77 67.7273 26.9217 67.7273 28.6058C67.7284 30.2712 66.5052 31.4416 65.0873 31.4416ZM52.9015 25.363V27.3474H57.6513C57.5094 28.4639 57.1376 29.279 56.57 29.8455C55.8792 30.5363 54.7979 31.2986 52.9015 31.2986C49.9777 31.2986 47.6919 28.9413 47.6919 26.0175C47.6919 23.0937 49.9777 20.7364 52.9015 20.7364C54.4789 20.7364 55.6306 21.3568 56.4809 22.1543L57.8812 20.754C56.6932 19.6199 55.1169 18.752 52.9015 18.752C48.8964 18.752 45.5293 22.0124 45.5293 26.0175C45.5293 30.0226 48.8964 33.283 52.9015 33.283C55.063 33.283 56.6943 32.5735 57.9692 31.2447C59.2804 29.9335 59.6885 28.0899 59.6885 26.6016C59.6885 26.1418 59.6533 25.7161 59.5818 25.3619H52.9015V25.363ZM102.74 26.9041C102.351 25.8591 101.163 23.9264 98.7352 23.9264C96.3251 23.9264 94.322 25.8228 94.322 28.6047C94.322 31.2271 96.3075 33.283 98.9651 33.283C101.109 33.283 102.35 31.9718 102.865 31.2095L101.27 30.1458C100.738 30.9257 100.011 31.4394 98.9651 31.4394C97.9201 31.4394 97.1754 30.9609 96.6969 30.0215L102.953 27.4343L102.74 26.9041ZM96.3603 28.4639C96.3075 26.6555 97.7606 25.7348 98.8067 25.7348C99.6218 25.7348 100.313 26.1429 100.544 26.727L96.3603 28.4639ZM91.275 33.0003H93.3298V19.2492H91.275V33.0003ZM87.9068 24.9725H87.8364C87.3755 24.4225 86.4889 23.9264 85.3735 23.9264C83.0338 23.9264 80.8899 25.9823 80.8899 28.6234C80.8899 31.2458 83.0338 33.2841 85.3735 33.2841C86.49 33.2841 87.3755 32.788 87.8364 32.2215H87.9068V32.8947C87.9068 34.6844 86.9498 35.6414 85.4087 35.6414C84.1503 35.6414 83.3704 34.7383 83.0514 33.976L81.2617 34.7207C81.7754 35.9604 83.1394 37.485 85.4087 37.485C87.8188 37.485 89.8571 36.0671 89.8571 32.6109V24.2113H87.9079V24.9725H87.9068ZM85.5506 31.4416C84.1327 31.4416 82.9458 30.2536 82.9458 28.6234C82.9458 26.9745 84.1327 25.77 85.5506 25.77C86.9498 25.77 88.0487 26.9745 88.0487 28.6234C88.0487 30.2536 86.9498 31.4416 85.5506 31.4416ZM112.37 19.2492H107.452V33.0003H109.503V27.7907H112.369C114.643 27.7907 116.881 26.144 116.881 23.5205C116.881 20.897 114.645 19.2492 112.37 19.2492ZM112.422 25.8767H109.503V21.1632H112.422C113.957 21.1632 114.828 22.4337 114.828 23.5205C114.828 24.5853 113.957 25.8767 112.422 25.8767ZM125.108 23.9022C123.622 23.9022 122.083 24.5567 121.446 26.0076L123.267 26.7677C123.657 26.0076 124.383 25.759 125.143 25.759C126.204 25.759 127.283 26.3959 127.301 27.5278V27.6697C126.929 27.4574 126.133 27.1395 125.16 27.1395C123.197 27.1395 121.197 28.2186 121.197 30.2349C121.197 32.0752 122.808 33.2599 124.612 33.2599C125.991 33.2599 126.752 32.6406 127.23 31.9146H127.3V32.9761H129.282V27.7038C129.283 25.264 127.46 23.9022 125.108 23.9022ZM124.859 31.4383C124.188 31.4383 123.25 31.1017 123.25 30.2701C123.25 29.2086 124.418 28.8016 125.427 28.8016C126.328 28.8016 126.753 28.9963 127.301 29.2614C127.142 30.5363 126.045 31.4383 124.859 31.4383ZM136.5 24.2025L134.148 30.1645H134.077L131.635 24.2025H129.424L133.086 32.535L130.998 37.1704H133.139L138.783 24.2025H136.5ZM118.014 33.0003H120.065V19.2492H118.014V33.0003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5417 11.2675C52.5417 12.1893 52.2689 12.923 51.7222 13.4708C51.1018 14.122 50.2922 14.4476 49.2978 14.4476C48.3452 14.4476 47.5345 14.1176 46.869 13.4576C46.2024 12.7965 45.8691 11.9781 45.8691 11.0013C45.8691 10.0234 46.2024 9.20501 46.869 8.54501C47.5345 7.88391 48.3452 7.55391 49.2978 7.55391C49.7708 7.55391 50.2229 7.64631 50.6519 7.83001C51.082 8.01481 51.4263 8.26011 51.6837 8.56701L51.104 9.14781C50.6673 8.62531 50.0656 8.36461 49.2967 8.36461C48.6015 8.36461 48.0009 8.60881 47.4938 9.09721C46.9867 9.58561 46.7337 10.2203 46.7337 11.0002C46.7337 11.7801 46.9867 12.4148 47.4938 12.9032C48.0009 13.3916 48.6015 13.6358 49.2967 13.6358C50.0337 13.6358 50.6486 13.3905 51.1403 12.8988C51.4593 12.5787 51.6441 12.1332 51.6936 11.5623H49.2967V10.7692H52.4944C52.5274 10.9419 52.5417 11.108 52.5417 11.2675Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6128 8.51097H54.6076V10.6032H57.318V11.3963H54.6076V13.4885H57.6128V14.3003H53.7595V7.70027H57.6128V8.51097Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1888 14.3003H60.3407V8.51097H58.4971V7.70027H63.0324V8.51097H61.1888V14.3003Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3137 14.3003V7.70027H67.1618V14.3003H66.3137Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9228 14.3003H70.0748V8.51097H68.2312V7.70027H72.7665V8.51097H70.9228V14.3003Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3517 13.4478C80.7027 14.1144 79.8964 14.4477 78.9317 14.4477C77.967 14.4477 77.1607 14.1144 76.5128 13.4478C75.8638 12.7812 75.5404 11.965 75.5404 11.0003C75.5404 10.0356 75.8638 9.21936 76.5128 8.55276C77.1607 7.88616 77.967 7.55176 78.9317 7.55176C79.8909 7.55176 80.6961 7.88726 81.3473 8.55716C81.9985 9.22706 82.3241 10.0411 82.3241 11.0003C82.3241 11.965 81.9996 12.7812 81.3517 13.4478ZM77.1387 12.8945C77.6271 13.3895 78.2244 13.6359 78.9317 13.6359C79.639 13.6359 80.2374 13.3884 80.7247 12.8945C81.2131 12.3995 81.4584 11.7681 81.4584 11.0003C81.4584 10.2325 81.2131 9.60106 80.7247 9.10606C80.2374 8.61106 79.639 8.36466 78.9317 8.36466C78.2244 8.36466 77.6271 8.61216 77.1387 9.10606C76.6514 9.60106 76.4061 10.2325 76.4061 11.0003C76.4061 11.7681 76.6514 12.3995 77.1387 12.8945Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5143 14.3003V7.70027H84.5461L87.7537 12.834H87.79L87.7537 11.5624V7.70027H88.6018V14.3003H87.7163L84.3602 8.91687H84.3239L84.3602 10.1885V14.3003H83.5143Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5417 11.2675C52.5417 12.1893 52.2689 12.923 51.7222 13.4708C51.1018 14.122 50.2922 14.4476 49.2978 14.4476C48.3452 14.4476 47.5345 14.1176 46.869 13.4576C46.2024 12.7965 45.8691 11.9781 45.8691 11.0013C45.8691 10.0234 46.2024 9.20501 46.869 8.54501C47.5345 7.88391 48.3452 7.55391 49.2978 7.55391C49.7708 7.55391 50.2229 7.64631 50.6519 7.83001C51.082 8.01481 51.4263 8.26011 51.6837 8.56701L51.104 9.14781C50.6673 8.62531 50.0656 8.36461 49.2967 8.36461C48.6015 8.36461 48.0009 8.60881 47.4938 9.09721C46.9867 9.58561 46.7337 10.2203 46.7337 11.0002C46.7337 11.7801 46.9867 12.4148 47.4938 12.9032C48.0009 13.3916 48.6015 13.6358 49.2967 13.6358C50.0337 13.6358 50.6486 13.3905 51.1403 12.8988C51.4593 12.5787 51.6441 12.1332 51.6936 11.5623H49.2967V10.7692H52.4944C52.5274 10.9419 52.5417 11.108 52.5417 11.2675Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6128 8.51097H54.6076V10.6032H57.318V11.3963H54.6076V13.4885H57.6128V14.3003H53.7595V7.70027H57.6128V8.51097Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1888 14.3003H60.3407V8.51097H58.4971V7.70027H63.0324V8.51097H61.1888V14.3003Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3137 14.3003V7.70027H67.1618V14.3003H66.3137Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9228 14.3003H70.0748V8.51097H68.2312V7.70027H72.7665V8.51097H70.9228V14.3003Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3517 13.4478C80.7027 14.1144 79.8964 14.4477 78.9317 14.4477C77.967 14.4477 77.1607 14.1144 76.5128 13.4478C75.8638 12.7812 75.5404 11.965 75.5404 11.0003C75.5404 10.0356 75.8638 9.21936 76.5128 8.55276C77.1607 7.88616 77.967 7.55176 78.9317 7.55176C79.8909 7.55176 80.6961 7.88726 81.3473 8.55716C81.9985 9.22706 82.3241 10.0411 82.3241 11.0003C82.3241 11.965 81.9996 12.7812 81.3517 13.4478ZM77.1387 12.8945C77.6271 13.3895 78.2244 13.6359 78.9317 13.6359C79.639 13.6359 80.2374 13.3884 80.7247 12.8945C81.2131 12.3995 81.4584 11.7681 81.4584 11.0003C81.4584 10.2325 81.2131 9.60106 80.7247 9.10606C80.2374 8.61106 79.639 8.36466 78.9317 8.36466C78.2244 8.36466 77.6271 8.61216 77.1387 9.10606C76.6514 9.60106 76.4061 10.2325 76.4061 11.0003C76.4061 11.7681 76.6514 12.3995 77.1387 12.8945Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5143 14.3003V7.70027H84.5461L87.7537 12.834H87.79L87.7537 11.5624V7.70027H88.6018V14.3003H87.7163L84.3602 8.91687H84.3239L84.3602 10.1885V14.3003H83.5143Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1604_22317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 8.29173C11.5427 8.63053 11.3535 9.15633 11.3535 9.83723V34.1648C11.3535 34.8468 11.5427 35.3715 11.8628 35.7103L11.9442 35.7895L25.5721 22.1616V22.001V21.8404L11.9442 8.21143L11.8628 8.29173Z",
    fill: "url(#paint0_linear_1604_22317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.114 26.7058L25.5721 22.1617V22.0011V21.8405L30.1151 17.2975L30.2174 17.3558L35.5997 20.4138C37.1364 21.2872 37.1364 22.7161 35.5997 23.5906L30.2174 26.6486L30.114 26.7058Z",
    fill: "url(#paint1_linear_1604_22317)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1604_22317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2179 26.6474L25.5715 22.001L11.8633 35.7103C12.3693 36.2471 13.2064 36.3131 14.1491 35.7785L30.2179 26.6474Z",
    fill: "url(#paint2_linear_1604_22317)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.2179 17.3547L14.1491 8.22466C13.2064 7.68896 12.3693 7.75606 11.8633 8.29286L25.5726 22.0022L30.2179 17.3547Z",
    fill: "url(#paint3_linear_1604_22317)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1604_22317",
    x: 11.3535,
    y: 7.85498,
    width: 25.3987,
    height: 28.2927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1604_22317"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1604_22317",
    result: "effect2_innerShadow_1604_22317"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1604_22317",
    x: 11.8633,
    y: 22.001,
    width: 18.3546,
    height: 14.1467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1604_22317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1604_22317",
    x1: 24.3641,
    y1: 9.57983,
    x2: 5.9039,
    y2: 28.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1604_22317",
    x1: 37.6,
    y1: 22.0011,
    x2: 10.9845,
    y2: 22.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1604_22317",
    x1: 27.6946,
    y1: 24.5243,
    x2: 2.66025,
    y2: 49.5586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1604_22317",
    x1: 8.41082,
    y1: 0.194443,
    x2: 19.5894,
    y2: 11.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.f2bc8af935b8f78b13805ab7265823f5.svg";
export { ForwardRef as ReactComponent };